import { ClientSoftwareResponse } from '@kcftech/prometheus-client';
import { sdClient } from 'contexts/SDKClientContext';
import {
    BaseDataSourceOptions,
    DataSourceQuery,
    DataSourceSort,
} from 'custom_hooks/data_hooks/data_source/data_source';
import {
    PagedDataSource,
    usePagedDataSource,
} from 'custom_hooks/data_hooks/data_source/usePagedDataSource';
import { buildOrderBySearchScore, Filter, toDataSourceResult } from 'utils/query_v3';

export const defaultClientSoftwareSort: DataSourceSort[] = [
    { field: 'Name', dir: 'asc' },
];

export type ClientSoftwareFilter = Readonly<{
    nameSearch: string | undefined;
}>;

export type UseClientSoftwareDataSourceOptions = BaseDataSourceOptions<
    ClientSoftwareResponse,
    ClientSoftwareFilter
>;

export type ClientSoftwareDataSource = PagedDataSource<
    ClientSoftwareResponse,
    ClientSoftwareFilter
>;

const getAllClientSoftwares: DataSourceQuery<
    ClientSoftwareResponse,
    ClientSoftwareFilter
> = ({ filter: { nameSearch }, sort, page, pageLimit }) => {
    const filter = nameSearch ? Filter.search(['Name'], nameSearch) : undefined;
    const orderBy = buildOrderBySearchScore({
        searchFields: ['Name'],
        searchText: nameSearch,
        orderBys: sort,
    });
    return toDataSourceResult(
        sdClient.getClientSoftwares({ filter, page, pageLimit, orderBy }),
    );
};

export function usePagedClientSoftwareDataSource({
    defaultSort = defaultClientSoftwareSort,
    ...options
}: UseClientSoftwareDataSourceOptions): ClientSoftwareDataSource {
    return usePagedDataSource({
        defaultSort,
        ...options,
        query: getAllClientSoftwares,
    });
}
